<img 
    [ngStyle]="{'height': height}"
    class="img-fluid" 
    [src]="getLogoTypeUrl()" 
    alt="logo"
/>